import * as React from 'react';
import {Avatar, Typography} from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from '../../axios';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {useNavigate} from 'react-router-dom';
import {
  useRemoveComment,
  useLikeComment,
  useDislikeComment,
} from './hooks/useComments';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import parse from "html-react-parser";

const ActualityCommentAnswer = ({comment, contentId}) => {
  const {removeComment} = useRemoveComment(contentId);
  const {likeComment} = useLikeComment();
  const {dislikeComment} = useDislikeComment();
  const {mode} = useDarkMode();

  const handleClick = () => {
    if (comment.liked) {
      dislikeComment(comment.id);
    } else {
      likeComment(comment.id);
    }
  };

  return (
    <div>
      <Typography component={'div'} class={'commentAnswerContainer'}>
        <Avatar src={`${axios.defaults.apiBaseURL}/${comment.image}`} />
        <Typography component={'div'} style={{marginLeft: 20, flexGrow: 100}}>
          <Typography
            variant={'h4'}
            style={{fontWeight: '700', color: mode.settings.textColor3}}>
            {comment.userName}
          </Typography>
          <Typography
            component={'div'}
            id={'answerContainer'}
            style={{backgroundColor: mode.settings.inputBackgroundColor}}>
            <Typography
              component={'div'}
              variant={'h5'}
              style={{
                fontSize: '18px',
                fontWeight: '400',
                width: '-webkit-fill-available',
              }}>
              <Typography style={{color: mode.settings.textColor3}}>
                {parse(comment.text)}
              </Typography>
              <Typography
                component={'div'}
                id={'commentState'}
                sx={{color: mode.settings.textColor}}>
                <Typography component={'div'} style={{display: 'flex'}}>
                  {comment.liked ? (
                    <FavoriteIcon
                      role="img"
                      aria-label={'Vous avez aimé le commentaire'}
                      onClick={handleClick}></FavoriteIcon>
                  ) : (
                    <FavoriteBorderIcon
                      role="img"
                      aria-label={"Vous n'avez pas encore aimé le commentaire"}
                      onClick={handleClick}></FavoriteBorderIcon>
                  )}
                  <span className="communityAttributes">
                    {comment.likeCount} J'aime
                  </span>
                </Typography>
              </Typography>
            </Typography>
            <Typography
              component={'div'}
              id={'commentAnswerSeparator'}></Typography>
            <Typography component={'div'} id={'commentAnswerButtonContainer'}>
              <DeleteIcon
                role="img"
                aria-label={'Suprimer le commentaire'}
                onClick={() => removeComment(comment.id)}
                style={{marginLeft: '10px'}}></DeleteIcon>
            </Typography>
          </Typography>
        </Typography>
      </Typography>
    </div>
  );
};

export default ActualityCommentAnswer;
